export const coerceAttributeBoolean = (value: unknown): boolean => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const lower = value.toLowerCase();
    return value === "1" || lower === "true";
  }
  return false;
};
